export default {
  'menu.welcome': 'Bienvenido',
  'menu.home': 'Inicio',
  'menu.admin': 'Admin',
  'menu.login': 'Authenticarse',
  'menu.register': 'Registrarse',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Análysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Lugar de Trabajo',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulario',
  'menu.list': 'Lista',
  'menu.profile': 'Perfil',
  'menu.result': 'Resultado',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Disparador',
  'menu.account': 'Cuenta',
  'menu.account.logout': 'Salir',
  'menu.exception.not-permission.description':
    'Lo sentimos, no está autorizado a acceder a esta página.',
  'menu.embedTemplate': 'Plantilla Embebida',

  // BEGIN :: Side Menu Translations
  'menu.options': 'Opciones',
  'menu.processes': 'Procesos',
  'menu.processes.details': 'Detalles',
  'menu.processes.actions': 'Acciones',
  'menu.processes.start': 'Iniciar Solicitud',
  'menu.tasks': 'Tareas',
  'menu.tasks.tasks': 'Tareas',
  'menu.tasks.myDay': 'Mi Dia',
  'menu.tasks.favorites': 'Favoritos',
  'menu.tasks.planned': 'Planeado',
  'menu.tasks.overdue': 'Vencidas',
  'menu.tasks.miscellaneous': 'Tareas Varias',
  'menu.applications': 'Solicitudes',
  'menu.applications.details': 'Detalles de Solicitud',
  'menu.applications.bulkDetails': 'Detalles de Carga Masiva',
  'menu.applications.continue': 'Continuar',
  'menu.reports': 'Reportes',
  'menu.agents': 'Agentes',
  'menu.reports.details': 'Detalles de reporte',
  'menu.agents.details': 'Detalles de agente',
  'menu.administration': 'Administración',
  'menu.connections': 'Conexiones',
  'menu.connections.api': 'Conexiones API',
  'menu.connections.database': 'Conexiones Bases de datos',
  'menu.connections.queries': 'Consultas Bases de datos',
  'menu.connections.callback': 'Devolver Llamada',
  'menu.entities': 'Entidades',
  'menu.entities.details': 'Detalles',
  'menu.entities.manage-entities': 'Administrar Entidades',
  'menu.entities.byGroup': 'Por Grupo',
  'menu.entities.groups': 'Grupos de Entidades',
  'menu.configuration': 'Configuración',
  'menu.configuration.users': 'Usuarios',
  'menu.configuration.digital-certificates': 'Certificados Digitales',
  'menu.configuration.users-groups': 'Grupos de Usuarios',
  'menu.configuration.process-group': 'Grupos de Procesos',
  'menu.configuration.positions': 'Puestos',
  'menu.configuration.approvers': 'Aprobadores',
  'menu.configuration.approvers.userGroup': 'Por grupos',
  'menu.configuration.approvers.groupAndPosition': 'Por grupo y puesto',
  'menu.configuration.approvers.entity': 'Por entidad',
  'menu.configuration.approvers.entityAndUserGroup': 'Por entidad y grupo',
  'menu.configuration.approvers.entityAndPosition': 'Por entidad y puesto',
  'menu.configuration.approvers.globalUserGroupAndArea': 'Por grupo y área',
  'menu.configuration.approvers.globalEntityAndArea': 'Por entidad y área',
  'menu.configuration.email-formats': 'Formatos de Correos',
  'menu.configuration.environments': 'Entornos',
  'menu.configuration.process-portal': 'Portal de Procesos',
  'menu.configuration.azure-servers': 'Servidores y Servicios Azure',
  'menu.configuration.reports-tokens': 'Tokens de Reportes',
  'menu.configuration.reports': 'Reportes',
  'menu.configuration.entities': 'Entidades',
  'menu.configuration.entities.details': 'Detalles',
  'menu.configuration.reports-groups': 'Grupo de Reportes',
  'menu.configuration.aiConsumptions': 'Consumos de IA',
  'menu.configuration.traces': 'Trazas',
  'menu.configuration.accessLog': 'Registros de Acceso',
  'menu.configuration.delegations': 'Delegaciones',
  'menu.configuration.delegations.item': 'Item',
  'menu.configuration.areas': 'Áreas',
  'menu.configuration.custom-list-groups': 'Grupos de Listas',
  'menu.configuration.dynamic-entity-groups': 'Grupo de Entidades Dinámicas',
  'menu.configuration.api-connection-group': 'Grupo de Conexiones Api',
  'menu.configuration.shortenedUrl': 'URLs Abreviadas',
  'menu.configuration.sequence': 'Secuencias',
  'menu.configuration.administration': 'Administración',
  'menu.configuration.email-traces': 'Trazas Correo',
  'menu.configuration.extra-user-fields': 'Campos Extra Usuario',
  'menu.processes.config': 'Configurar Proceso',
  'menu.connections.groups': 'Grupos',
  'menu.connections.connections': 'Conexiones',
  'menu.lists': 'Listas',
  'menu.lists.groups': 'Grupos',
  'menu.lists.byGroup': 'Por Grupo',
  'menu.lists.details': 'Detalles',
  'menu.user-management': 'Gestión de Usuarios',
  'menu.lists-dynamic-entities': 'Listas y Entidades Dinámicas',
  'menu.integration-connections': 'Integración y Conexiones API',
  'menu.check-auditory': 'Seguimiento y Auditoría',
  'menu.support': 'Soporte',
  'menu.configurations': 'Configuraciones',
  'menu.filter.result': '({number}) Resultados',
  // END :: Side Menu Translations
};
